import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { Schema, Table } from 'services/action';
import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  weight_less: 0,
  point: 0,
};

export const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['schema_kurir']);

  const dummy = Array.from({ length: 2 }, (v, i) => i);

  const [{ weight_less, point, isLoading }, setState] =
    React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      weight_less,
      point,
    };

    if (data) {
      const submit = await Dispatch(Schema.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('schema_kurir', StateTable));
      }
    } else {
      const submit = await Dispatch(Schema.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('schema_kurir', StateTable));
      }
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      weight_less: data?.weight_less,
      point: data?.point,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="row ">
        <div className="col-12 col-md-6">
          <Form.Input
            autoComplete="off"
            label="Maksimal Berat (Kg) "
            name="weight_less"
            type="number"
            value={weight_less}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                weight_less: e?.target?.valueNumber,
              }))
            }
            error={StateForm?.errors?.weight_less}
          />
        </div>
        <div className="col-12 col-md-6">
          <Form.Input
            autoComplete="off"
            label="Jumlah Point"
            name="point"
            type="number"
            value={point}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                point: e?.target?.valueNumber,
              }))
            }
            error={StateForm?.errors?.point}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button
          type="button"
          className={cn(
            StateForm?.loading ? 'btn-loading' : '',
            'mt-3 btn btn-primary px-4 py-3'
          )}
          disabled={StateForm?.loading}
          onClick={$handleSubmit}
        >
          Simpan
        </Button>
      </div>
    </div>
  );
};
